import { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import LoadingButton from './utils/Loading';
import { useNavigate } from 'react-router-dom';
import LoadingAction from './utils/LoadingAction';

const Header = () => {
  const [viewAllLoading, setViewAllLoading] = useState(false);
  const [whatLoading, setWhatLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
  }, []);

  return (
    <header id="home" className="header">
      <div className="overlay"></div>
      <div className="header-content" data-aos="fade-right">
        <h1 className="header-title mb-1">
          <span className="up">HI!</span>
          <span className="down">I am <br/>Tehzeeb Jahan</span>
        </h1>
        <p className="header-subtitle mb-1">MERN-STACK DEVELOPER</p>
        <p className="header-description mb-0">Building modern, responsive and scalable web applications for businesses.</p>

        <div className="hero-buttons">
          <LoadingButton
            isLoading={viewAllLoading}
            onClick={() =>
              LoadingAction(
                setViewAllLoading,
                () => navigate("/allProjects")
              )
            }
            className="btn btn-primary rounded-pill shadow"
          >
            Visit My Projects
          </LoadingButton>

          <LoadingButton
            isLoading={whatLoading}
            onClick={() =>
              LoadingAction(
                setWhatLoading,
                () => {
                  const newWindow = window.open(
                    "https://wa.me/918982896759?text=Hi%20Tehzeeb,%20I%20visited%20your%20portfolio%20and%20would%20like%20to%20discuss%20a%20project.", 
                    "_blank", 
                    "noopener,noreferrer"
                  );

                  if (newWindow) {
                    newWindow.opener = null
                  }
                }
              )
            }
            className="btn btn-outline-primary rounded-pill shadow"
          >
            WhatsApp Me
          </LoadingButton>
        </div>

        <div className="hero-stats">
          <div className="stat">
            <h3>8+</h3>
            <p>Projects</p>
          </div>

          <div className="stat">
            <h3>10+</h3>
            <p>Technologies</p>
          </div>

          <div className="stat">
            <h3>100%</h3>
            <p>Responsive</p>
          </div>

          <div className="stat">
            <h3>24h</h3>
            <p>Response</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;